/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'format-italic': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4h-8z"/>'
  }
})
